export const GODMOD = 'GODMOD'